export const CollectionTypes = {
  GENERAL: 'general',
  PULSE: 'pulse',
  MEETING: 'meeting',
  CONCURRENT: 'concurrent',
  SURVEY: 'survey',
  PROGRAM: 'program'
};

export const collectionTypeFromString = (type) => {
  const lower = (type || '').toLowerCase();
  switch (lower) {
    case CollectionTypes.GENERAL:
    case CollectionTypes.CONCURRENT:
    case CollectionTypes.SURVEY:
    case CollectionTypes.PROGRAM:
    case CollectionTypes.PULSE:
    case CollectionTypes.MEETING:
    case CollectionTypes.RECIPE:
      return lower;
    default:
      throw Error(`Invalid collection type: ${type}`);
  }
};
